import React, { useState, useRef } from 'react'
import { func, string } from 'prop-types'
import { useTranslation } from 'react-i18next'
import Button from '@ingka/button'
import useOutsideAlerter from 'hooks/useOutsideAlerter'

require('./MissingFeatureModal.scss')

const MissingFeatureModal = ({ onClose, body, headerText, ctaText, onCtaClick, closeBtnText }) => {
    const { t } = useTranslation()
    const [isOpen, setIsOpen] = useState(true)
    const wrapperRef = useRef(null)
    const closeModal = () => {
        setIsOpen(false)
        if (onClose) {
            onClose()
        }
    }

    // We want to stop propagation here since there is a mousedown event listener
    // on the parent component in Preview.jsx
    const onMouseDown = (e) => e.stopPropagation()

    // If the user clicks outside, the modal is closed
    useOutsideAlerter(wrapperRef, closeModal)

    if (!isOpen) {
        return null
    }
    const closeCtaText = closeBtnText || t('design.got it')
    const header = headerText || t('design.did not find a surface')
    return (
        <div ref={wrapperRef} className="MissingFeatureModal">
            <div className="modal">
                <div className="modalHeader">
                    <div>{header}</div>
                </div>
                <div className="modalContent">{body}</div>
                <div className="ctaContainer">
                    {onCtaClick && (
                        <Button onMouseDown={onMouseDown} onClick={onCtaClick} type="secondary" text={ctaText} />
                    )}
                    <Button onMouseDown={onMouseDown} onClick={closeModal} type="primary" text={closeCtaText} />
                </div>
            </div>
        </div>
    )
}

MissingFeatureModal.defaultProps = {
    onClose: null,
    ctaText: null,
    onCtaClick: null,
    headerText: null,
    closeBtnText: null,
}

MissingFeatureModal.propTypes = {
    onClose: func,
    body: string.isRequired,
    ctaText: string,
    onCtaClick: func,
    headerText: string,
    closeBtnText: string,
}

export default MissingFeatureModal
